export enum CertificationCourse {
	HALF_DAY_SBEX_HIGH_PRESSURE = 'half_day_sbex_high_pressure',
	HALF_DAY_SBEX_LOW_PRESSURE = 'half_day_sbex_low_pressure',
	SBEX_HIGH_PRESSURE = 'sbex_high_pressure',
	SBEX_LOW_PRESSURE = 'sbex_low_pressure',
	SBEX_MPI = 'sbex_mpi',
	SBEX_PHASTITE = 'sbex_phastite',
}
